import { render, staticRenderFns } from "./AdministratorsTabLinks.vue?vue&type=template&id=64976155"
import script from "./AdministratorsTabLinks.vue?vue&type=script&lang=js"
export * from "./AdministratorsTabLinks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports